import React from "react";
import LegalLayout from "./LegalLayout";

export default function Terms() {
  return (
    <LegalLayout title="Terms of Use" effectiveDate="February 1, 2026">
      <p>These Terms of Use ("Terms") are a binding agreement between you and <b>TaskHive LLC</b> ("we," "us," or "our"), operator of Home Cost Path. By accessing or using Home Cost Path, you agree to these Terms. If you do not agree, do not use the service.</p>

      <h2>Educational tool only — not lending, brokerage, or advice</h2>
      <p>Home Cost Path is an educational planning tool. Home Cost Path does <b>not</b>:</p>
      <ul>
        <li>Originate mortgage loans, negotiate loan terms, or submit applications to lenders.</li>
        <li>Sell mortgage leads or forward your information to lenders.</li>
        <li>Provide mortgage-broker, real-estate-brokerage, appraisal, underwriting, legal, tax, insurance, or financial-advisory services.</li>
        <li>Determine your eligibility for any loan program or the VA Home Loan Guaranty program.</li>
      </ul>
      <p>All outputs are <b>estimates for planning purposes only</b>. Final figures — interest rate, closing costs, funding fees, appraisal values, property tax, insurance, and the amount of cash you actually need to close — must be obtained from your lender, closing/settlement provider, insurer, taxing authority, or, for VA-related items, from the U.S. Department of Veterans Affairs. Home Cost Path is not affiliated with or endorsed by the U.S. Department of Veterans Affairs or any other government agency.</p>

      <h2>Accounts</h2>
      <p>You may create a free account or purchase a Home Buying Pass. You are responsible for keeping your password confidential and for all activity under your account.</p>

      <h2>Home Buying Pass</h2>
      <p>The Home Buying Pass is a <b>one-time payment of $29.99 for 90 days of access</b> to premium Home Cost Path features (unlimited saved homes, PDF export, shareable read-only report links, 3-way compare, VA-tools shell). The Home Buying Pass <b>does not automatically renew</b>. See our <a href="/refund">Refund Policy</a> for cancellation and refund terms.</p>

      <h2>Acceptable use</h2>
      <ul>
        <li>Do not attempt to reverse-engineer, disassemble, or scrape the service.</li>
        <li>Do not misuse the shared-report feature to publish personal or confidential financial information about anyone other than yourself.</li>
        <li>Do not attempt to circumvent authentication, entitlement gates, or rate limits.</li>
        <li>Do not use Home Cost Path for any unlawful purpose or in violation of these Terms.</li>
      </ul>

      <h2>Intellectual property</h2>
      <p>Home Cost Path, its logo, and the underlying software are the property of TaskHive LLC. You retain ownership of the information you enter. You grant us a limited license to store, process, and display that information solely to operate the service for you.</p>

      <h2>Third-party services</h2>
      <p>Home Cost Path integrates with Stripe (payments), Emergent (infrastructure and OAuth), and PostHog (analytics). Your use of those services is also governed by their respective terms and privacy policies.</p>

      <h2>Disclaimer of warranties</h2>
      <p>HOME COST PATH IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT, AND ACCURACY. WE DO NOT GUARANTEE THAT CALCULATIONS ARE ERROR-FREE OR THAT THEY REFLECT YOUR ACTUAL LOAN TERMS OR CLOSING COSTS.</p>

      <h2>Limitation of liability</h2>
      <p>TO THE MAXIMUM EXTENT PERMITTED BY LAW, TASKHIVE LLC AND ITS AFFILIATES, EMPLOYEES, AND AGENTS WILL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUES, ARISING OUT OF YOUR USE OF HOME COST PATH. OUR TOTAL LIABILITY FOR DIRECT DAMAGES WILL NOT EXCEED THE AMOUNT YOU PAID TO US IN THE 12 MONTHS BEFORE THE CLAIM.</p>

      <h2>Indemnification</h2>
      <p>You agree to indemnify TaskHive LLC against claims arising from your misuse of Home Cost Path or your violation of these Terms.</p>

      <h2>Termination</h2>
      <p>We may suspend or terminate your account for violation of these Terms. You may close your account at any time by emailing <a href="mailto:support@homecostpath.com">support@homecostpath.com</a>.</p>

      <h2>Governing law</h2>
      <p>These Terms are governed by the laws of the State in which TaskHive LLC is organized, without regard to conflict-of-laws principles. <em>[Specific state, venue, and dispute-resolution clauses to be confirmed by counsel.]</em></p>

      <h2>Changes</h2>
      <p>We may update these Terms. Continued use of Home Cost Path after changes means you accept them.</p>

      <h2>Contact</h2>
      <p><a href="mailto:support@homecostpath.com">support@homecostpath.com</a></p>
    </LegalLayout>
  );
}
